module.exports = __webpack_public_path__ + "img/1546769560.2b2a6c8e.jpg";